import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

  type QuizDTO = object & ApiError

export const AddBookToCart = (bookId:string): Promise<QuizDTO> => {
    return axios.post(`/cart/addBookToCart/${bookId}`)
        .then(response => response.data as QuizDTO);
};
